import { render, staticRenderFns } from "./ScoreItemManage.vue?vue&type=template&id=096c5872&scoped=true"
import script from "./ScoreItemManage.vue?vue&type=script&lang=js"
export * from "./ScoreItemManage.vue?vue&type=script&lang=js"
import style0 from "./ScoreItemManage.vue?vue&type=style&index=0&id=096c5872&prod&scoped=true&lang=css"
import style1 from "./ScoreItemManage.vue?vue&type=style&index=1&id=096c5872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c5872",
  null
  
)

export default component.exports